import React from 'react';
import './SideBar.css';

const SideBar = () => {

    return (

        <div className='general-sidebar-container'>
        
    <div className='home-page-con'>
    
        <br></br>
        <br></br>
        <h2>Categories</h2>
        
        <br></br>
        
          
          <label>Eye Health and Diseases</label>
          <br></br>
          <label>Anesthesia and Reanimation</label>
          <br></br>
          <label>Cardiology</label>
          <br></br>
          <label>Dermatology</label>
          <br></br>
          <label>Diagnostic Radiology</label>
          <br></br>
          <label>Ear Nose and Throat</label>
          <br></br>
          <label>Gastroenterology</label>
          <br></br>


          <label>Urology</label>
          <br></br>
          <label>Neurology</label>
          <br></br>
          <label>Ophthalmology</label>
          <br></br>
          <label>Pathology</label>
          <br></br>
          <label>Pediatrics</label>
          <br></br>
          <label>Surgery</label>
          <br></br>
          
         
  
    </div>

    </div>
    );

};
export default SideBar;